import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const useInboxTasksCreatedAtFilter = (): FilterDefinition => ({
  label: i18n.t('tasks.filter.created_at'),
  type: 'date',
  options: {
    mode: 'range',
  },
})
